import { useTranslation } from "react-i18next";
import faqData from "../contanst/faq.json";

export const useFAQ = () => {
  const { t } = useTranslation();

  const processAnswerText = (answerKey) => {
    const text = t(answerKey);

    if (answerKey === "faq.legal.answerWhatAreRallyDataProtectionPolicy") {
      return {
        type: "withLink",
        content: text,
        linkText: "Data Protection Policy",
        linkPath: "/profile/support/protection/policy",
      };
    }

    return {
      type: "text",
      content: text,
    };
  };

  const getAllFAQSections = () => {
    return faqData.map((section) => {
      const sectionKey = Object.keys(section)[0];
      const sectionData = section[sectionKey];

      return {
        key: sectionKey,
        title: t(sectionData.titleKey),
        detail: sectionData.detail.map((item) => ({
          question: t(item.questionKey),
          answer: processAnswerText(item.answerKey),
          questionKey: item.questionKey,
          answerKey: item.answerKey,
        })),
      };
    });
  };

  const getFAQSection = (sectionName) => {
    const section = faqData.find((item) => item[sectionName]);
    if (!section) return null;

    const sectionData = section[sectionName];
    return {
      title: t(sectionData.titleKey),
      detail: sectionData.detail.map((item) => ({
        question: t(item.questionKey),
        answer: processAnswerText(item.answerKey),
        questionKey: item.questionKey,
        answerKey: item.answerKey,
      })),
    };
  };

  const searchFAQ = (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === "") {
      return getAllFAQSections();
    }

    const searchLower = searchTerm.toLowerCase();
    const allSections = getAllFAQSections();

    return allSections
      .map((section) => {
        const filteredDetail = section.detail.filter((item) => {
          const questionText = item.question.toLowerCase();
          const answerText =
            typeof item.answer === "object"
              ? item.answer.content.toLowerCase()
              : item.answer.toLowerCase();

          return (
            questionText.includes(searchLower) ||
            answerText.includes(searchLower)
          );
        });

        return {
          ...section,
          detail: filteredDetail,
        };
      })
      .filter((section) => section.detail.length > 0);
  };

  return { getAllFAQSections, getFAQSection, searchFAQ };
};
